<template>
    <VDropdown auto-hide-on-mousedown class="actions-dropdown" placement="bottom-start" boundary="#app">
        <button :disabled="isDropdownDisabled" :class="{ disabled: isDropdownDisabled }" type="button">
            <img src="@/assets/message.svg" />
        </button>
        <template #popper>
            <ul class="dropdown-menu">
                <li
                    v-for="action in actions"
                    v-show="!disabled(action, item)"
                    :key="action.name"
                    v-close-popper
                    @click.stop.prevent="emit(action.name, item)"
                >
                    <img v-if="action.icon" :src="action.icon" />
                    <span> {{ action.title }} </span>
                </li>
            </ul>
        </template>
    </VDropdown>
</template>

<script>
    export default {
        props: {
            id: undefined, // id of the dropdown, necessary for dropdown functionality
            item: Object, // the list item, which is returned when an action is invoked
            actions: Array, // an Array of actions, emitted to parent as ('dropdownAction', action.name, item)
            /**
             * This is currently only used in PrescriptionSet, where certain actions are locked to the currently logged in user.
             * Prop is passed down from ActionTable, which currently has no use for it. This solution is not very clean,
             * but leaving it like this in case the same access control is needed elsewhere.
             */
            currentProfile: String, // the currently logged in user
        },

        data() {
            return {
                active: false,
            };
        },

        computed: {
            isDropdownDisabled() {
                return this.actions && this.actions.every((action) => action.disabled && action.disabled(this.item));
            },
        },

        methods: {
            emit(action, item) {
                this.$emit("dropdownAction", action, item);
                this.active = false;
            },
            toggle() {
                this.active = !this.active;
            },
            away() {
                this.active = false;
            },
            getImgUrl(pic) {
                return new URL(`/src/assets/actionIcons/${pic}`, import.meta.url).href;
            },
            disabled(action, item) {
                if (action.disabled) return action.disabled(item, this.currentProfile);
                else return false;
            },
        },
    };
</script>

<style lang="scss" scoped>
    @import "@/style/_variables.scss";

    .actions-dropdown {
        position: relative;

        .disabled {
            opacity: $disabled-opacity;
        }

        button {
            background: transparent;
            border: 1px solid $color-menu-button-border;
            border-radius: $border-radius;
            cursor: pointer;

            &:hover {
                background-color: #cee9f3;
                cursor: pointer;
            }
        }
    }

    .dropdown-menu {
        list-style: none;
        margin: 0;
        padding: 14px 0;
        background-color: #ffffff;
        border: 1px solid $color-menu-border;
        border-radius: $border-radius;
        min-width: $column-width;

        li {
            cursor: default;
            white-space: nowrap;
            display: flex;
            padding: 17px 25px;

            &:hover {
                background-color: $color-menu-hover;
            }

            img {
                height: 22px;
                width: 22px;
                margin-right: 11px;
            }
        }
    }
</style>
